export default __webpack_public_path__ + "static/media/thailand.411289db.mp3";